// src/main.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import { AppProviders } from "./app/providers/AppProviders.jsx";
import AppRouter from "./app/router/AppRouter.jsx";
import { CartProvider } from "./shared/contexts/CartContext.jsx";
import { supabaseConfigError } from "./supabaseClient.jsx";

// Design tokens (Tailwind + paleta Tesourinhos) — deve vir primeiro
import "./design-system/tokens/index.css";
// CSS base para comportamento de App (Safe Areas, etc.)
import "./mobile-app.css";

// Localiza o elemento 'root' no DOM (index.html)
const container = document.getElementById("root");

// Cria o root usando o método do React 18+
const root = createRoot(container);

function MissingConfigScreen({ message }) {
  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#fff_0%,#f8f5f1_100%)] px-4 py-8 text-warm-900">
      <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-3xl items-center justify-center">
        <div className="w-full rounded-[28px] border border-warm-200 bg-white p-6 shadow-[0_24px_80px_rgba(46,39,32,0.10)] sm:p-8">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-rose-500">
            Configuração ausente
          </p>
          <h1 className="mb-4 text-3xl font-bold text-warm-900">
            O deploy subiu, mas faltam variáveis do Supabase
          </h1>
          <p className="mb-4 text-sm leading-7 text-warm-700">
            Configure as variáveis de ambiente no Vercel e faça um novo deploy com cache limpo.
          </p>
          <pre className="overflow-x-auto rounded-2xl bg-warm-50 p-4 text-sm leading-6 text-warm-800 whitespace-pre-wrap">
            {message}
          </pre>
        </div>
      </div>
    </div>
  );
}

// Usa o método render() do objeto root
root.render(
  <React.StrictMode>
    {supabaseConfigError ? (
      <MissingConfigScreen message={supabaseConfigError} />
    ) : (
      <CartProvider>
        <AppProviders>
          <AppRouter />
        </AppProviders>
      </CartProvider>
    )}
  </React.StrictMode>,
);